import "./ProgressStyle.scss";
import { numeric } from "../../core/numeric";
var ProgressComponent = /** @class */ (function () {
    function ProgressComponent(progress, options) {
        this.progress = progress;
        this.options = options;
    }
    ProgressComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    ProgressComponent.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var style = "width: " + this.progress + "%";
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.color) {
            style += ";background:" + this.options.color;
        }
        if ((_b = this.options) === null || _b === void 0 ? void 0 : _b.style) {
            style += ";" + this.options.style;
        }
        var content = "";
        if ((_c = this.options) === null || _c === void 0 ? void 0 : _c.showPercent) {
            content = numeric.format(this.progress, (_e = (_d = this.options) === null || _d === void 0 ? void 0 : _d.percentFormat) !== null && _e !== void 0 ? _e : "0. %");
        }
        return {
            tag: "div",
            attr: { class: "progress-comp " + ((_g = (_f = this.options) === null || _f === void 0 ? void 0 : _f.class) !== null && _g !== void 0 ? _g : "") },
            children: [{
                    tag: "div",
                    attr: { class: "bar", style: style },
                    content: content
                }]
        };
    };
    ProgressComponent.prototype.setProgress = function (progress) {
        this.progress = progress;
    };
    ProgressComponent.prototype.getProgress = function () {
        return this.progress;
    };
    return ProgressComponent;
}());
export { ProgressComponent };
